export default __webpack_public_path__ + "static/media/saved-searches.5fa8c618.svg";